import { Component, Input } from '@angular/core';

@Component({
  selector: 'rm-buttonlink',
  templateUrl: './buttonlink.component.html',
  styleUrls: ['./buttonlink.component.scss'],
})
export class ButtonLinkComponent {
  @Input() href: string;
  @Input() disabled: boolean;
  @Input() design: 'normal' | 'primary' | 'alert' | 'gray' = 'normal';
  @Input() outlined: boolean = false;
  @Input() rounded: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() openNewTab?: boolean = true;
  @Input() class?: string;
}
